import { Preset } from "@/models/configurator/configurator_options";
import { StockState } from "./types";

export const getStock = (state: StockState):boolean | undefined => {
  return state.stock;
};

